const goalTypeOptions = [
	{ label: 'Personal', value: 'PS' },
	{ label: 'GSM / USM', value: 'DG' },
	{ label: 'Whole Group', value: 'WG' }
];

export {
	goalTypeOptions,
}
